import storeJS from 'store';
import expirePlugin from 'store/plugins/expire';

storeJS.addPlugin(expirePlugin);
